import React, { useState } from "react";
import { IoIosMenu } from "react-icons/io";
import "./styles.scss";
import { MdClose } from "react-icons/md";
import { FaUserAlt, FaCreativeCommonsSa } from "react-icons/fa";
import { IoIosSpeedometer } from "react-icons/io";
import { GoCalendar } from "react-icons/go";
import { BsInboxFill } from "react-icons/bs";
import { FiHelpCircle } from "react-icons/fi";
import { GiBookshelf } from "react-icons/gi";
import { TiGroup } from "react-icons/ti";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../../../../shared/resources/in-logo-small.png";

const NavBarMobile = () => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <div className="mobile-nav-wrapper d-block d-md-none">
        <IoIosMenu onClick={() => setShowMenu(true)} />
        <div>Dashboard</div>
      </div>
      <Container
        fluid
        className={
          showMenu
            ? "mobile-nav-menu d-block d-md-none show-menu"
            : "mobile-nav-menu d-md-none hide-menu"
        }
      >
        <MdClose className="close" onClick={() => setShowMenu(false)} />
        <Row className="mobile-nav-header">
          <Col className="logo" xs={6}>
            <img src={logo} alt="" />
          </Col>
        </Row>
        <Row className="navi-items">
          <Col xs={12}>
            <Container fluid className="px-2">
              <Row className="navi-item">
                <Col xs={12}>
                  <FaUserAlt />
                  Account
                </Col>
              </Row>
              <Row className="navi-item active">
                <Col xs={12}>
                  <IoIosSpeedometer />
                  Dashboard
                </Col>
              </Row>
              <Row className="navi-item">
                <Col xs={12}>
                  <GiBookshelf />
                  Courses
                </Col>
              </Row>
              <Row className="navi-item">
                <Col xs={12}>
                  <GoCalendar />
                  Calendar
                </Col>
              </Row>
              <Row className="navi-item">
                <Col xs={12}>
                  <BsInboxFill />
                  Inbox
                </Col>
              </Row>
              <Row className="navi-item">
              <Col xs={12}>
                <TiGroup />
                teams
              </Col>
            </Row>
              <Row className="navi-item">
                <Col xs={12}>
                  <FaCreativeCommonsSa />
                  Commons
                </Col>
              </Row>
              <Row className="navi-item">
                <Col xs={12}>
                  <FiHelpCircle />
                  Help
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NavBarMobile;
